import styled from "styled-components";

export const ContainerWidth = styled.div`
  background-color: ${(props) => props?.backgroundColor ?? "inherit"};
  overflow: hidden;
  @media only screen and (min-width: 769px) {
    width: 1016px;
    z-index: 2;
  }
`;

export const SectionContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background-color: ${(props) => props.backgroundColor || "inherit"};
  margin-bottom: ${(props) => props.marginBottom || "32px"};
  padding-left: ${(props) => props.paddingLeft || "24px"};
  padding-right: ${(props) => props.paddingRight || "24px"};

  @media only screen and (min-width: 769px) {
    margin-bottom: 64px;
    padding-left: 0px;
    padding-right: ${(props) => props.paddingRight || "0px"};
  }
`;

export const GallerySectionContainer = styled.div`
  padding-top: 24px;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;

  gap: 2.5vh;
  overflow: hidden;

  @media only screen and (max-width: 375px) {
    gap: 2vh;
  }

  @media only screen and (min-width: 769px) {
    gap: 24px;
    flex-wrap: nowrap;
  }
`;
